import React from 'react';
import { Link } from 'site-modules/shared/components/link/link';
import { CtaButtonText } from 'site-modules/shared/components/native-ad/native-ad-components/cta-button-text/cta-button-text';
import { DfpTracking } from 'site-modules/shared/components/native-ad/utils/dfp-tracking';
import { siteServedAdTrackingWrapper } from 'site-modules/shared/components/native-ad/site-served-ad-tracking-wrapper/site-served-ad-tracking-wrapper';
import {
  SiteServedAdDefaultProps,
  SiteServedAdPropTypes,
} from 'site-modules/shared/components/ad-unit/ad-unit-prop-types';
import classnames from 'classnames';
import PropTypes from 'prop-types';

function TypeBuyingGuideAdUI({
  adRef,
  adClickTrackingListener,
  adLoadTrackingListener,
  mobile = SiteServedAdDefaultProps.mobile,
  position = SiteServedAdDefaultProps.position,
  ivtClassName = SiteServedAdDefaultProps.ivtClassName,
  type,
  ctaUrl,
  clickOut = false,
  sponsoredLogo,
  showAdLabel = false,
  sponsoredImg,
  ctaText,
}) {
  const nativeStyle = `site-${type}bg`;

  return (
    <div
      ref={adRef}
      data-tracking-parent={nativeStyle}
      className={classnames('type-buying-guide-ad h-100 rounded-8 overflow-hidden bg-white pos-r', ivtClassName)}
    >
      <DfpTracking
        lineItemId={nativeStyle}
        mobile={mobile}
        nativeStyle={nativeStyle}
        position={position}
        slotRenderEndListener={adLoadTrackingListener}
      />
      <Link
        to={ctaUrl}
        target={clickOut ? '_blank' : '_self'}
        className="h-100 site-served-ad-link no-focus text-decoration-none d-block pos-r d-flex flex-md-column flex-lg-row justify-content-center align-items-center"
        style={{ minHeight: '96px' }}
        onClick={adClickTrackingListener}
      >
        <img src={sponsoredLogo} alt="" height={'18'} className="pos-a" style={{ top: '4px', left: '4px' }} />
        {showAdLabel && <div className="pos-a top-0 right-0 small px-0_25 site-served-label text-white">Ad</div>}
        <img
          src={sponsoredImg}
          alt=""
          width={'80'}
          height={'50'}
          style={{ objectFit: 'contain' }}
          className="me-1 me-md-0 me-lg-0_5 me-xl-1"
        />
        <span className="btn transform-none p-0 text-blue-30 size-20 fw-medium">
          <CtaButtonText text={ctaText} hideOpenIcon={!clickOut} />
        </span>
      </Link>
    </div>
  );
}

TypeBuyingGuideAdUI.propTypes = {
  ...SiteServedAdPropTypes,
  type: PropTypes.string.isRequired,
  ctaUrl: PropTypes.string.isRequired,
  sponsoredLogo: PropTypes.string.isRequired,
  sponsoredImg: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired,
  showAdLabel: PropTypes.bool,
  clickOut: PropTypes.bool,
};

const TypeBuyingGuideAdTrackingWrapper = siteServedAdTrackingWrapper(TypeBuyingGuideAdUI);

export function TypeBuyingGuideAd(props) {
  const creativeConfig = {
    creativeConfigData: {},
    traffickingData: {},
  };

  return <TypeBuyingGuideAdTrackingWrapper {...props} creativeConfig={creativeConfig} position={'1'} />;
}
